import { Component, DOCUMENT, HostListener, inject, Inject, OnDestroy, OnInit } from '@angular/core';
import * as AOS from 'aos';
import 'aos/dist/aos.css';
import {AccordionItem, DataService, ServiceItem} from "../../services/service-item.service";
import {DarkModeService} from "../../services/dark-mode.service";

@Component({
    selector: 'app-guest-main',
    templateUrl: './guest-main.component.html',
    styleUrl: './guest-main.component.scss',
    standalone: false
})
export class GuestMainComponent implements OnInit, OnDestroy {
  duration: number = 3000;
  currentYear = new Date().getFullYear();
  email: string = 'egov.helpdesk@ega.go.tz';
  public services: ServiceItem[] = [];
  public today: string = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date());
  private observer!: IntersectionObserver;
  private document: Document = inject(DOCUMENT)
  private dataService: DataService = inject(DataService);
  public accordionData: AccordionItem[] = [];
  public readonly timer: any;

  // --- State Properties ---
  public isAccessibilityMenuOpen: boolean = false;
  public showBackToTop: boolean = false;
  public mobileMenuOpen: boolean = false;
  public scrollY: number = 0;

  // --- Dark Mode State ---
  public activeLightMode: 'light' | 'night' = 'light';
  public isLightMode: boolean = true;

  // --- Accordion State ---
  public openIndex: number; // Default first item open


  private readonly darkModeService: DarkModeService = inject(DarkModeService);

  constructor() {
    this.timer = setInterval(() => {
      this.today = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(new Date());
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    clearInterval(this.timer);
  }

  ngOnInit(): void {
    this.services = this.dataService.getServices();
    this.accordionData = this.dataService.getAccordionData();

    // Initialize dark mode state
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';

    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic'
    });
  }

  /**
   * Toggles the open/closed state of an accordion item.
   * @param index The index of the clicked accordion item.
   */
  public toggleAccordion(index: number): void {
    this.openIndex = this.openIndex === index ? -1 : index;
  }

  items = [
    {
      text: 'How do I request for a service from e-Government Authority?',
      details: 'To request for a service please request for access for GISP system. Then proceed with login and select the service to request',
      selected: false
    },
    {
      text: 'Do institutions have to submit all ICT Projects to eGA?',
      details: 'Yes, institutions have to submit all ICT projects to eGA for review. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy',
      selected: false
    },
    {
      text: 'How is the Institutions maturity index measured?',
      details: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy',
      selected: false
    },
    {
      text: 'If facing an ICT security challenges, what should I do or who to contact?',
      details: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy',
      selected: false
    },
  ];

  public scrollTo(id: string): void {
    const element = this.document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  isScrolled = false;

  stats = [
    { value: '99.9%', label: 'Server Uptime' },
    { value: '50+', label: 'ICT Services' },
    { value: '24/7', label: 'Tech Support' },
    { value: '15min', label: 'Response Time' }
  ];

  links = [
    {name: 'Home', link: 'home'},
    {name: 'Services', link: 'services'},
    {name: 'How Do I', link: 'how-do-i'}
  ]

  steps = [
    { id: '01', question: 'How do I request a technical consultation?', answer: 'Use our search tool or portal to book a discovery session with our senior architects to evaluate your needs.' },
    { id: '02', question: 'What is the standard migration timeline?', answer: 'Most cloud migrations are executed within 48-72 hours, depending on the complexity of your data volume.' },
    { id: '03', question: 'Is 24/7 dedicated support included?', answer: 'Yes, every tier includes access to our Network Operations Center (NOC) for immediate emergency support.' },
    { id: '04', question: 'Can you audit my current security setup?', answer: 'Absolutely. We offer a deep-dive security audit to identify and patch vulnerabilities in your existing stack.' }
  ];

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const window = this.document.defaultView;
    if (!window) return;

    this.scrollY = window.pageYOffset || this.document.documentElement.scrollTop;
    this.isScrolled = this.scrollY > 50;

    // Back to top logic
    const totalHeight = this.document.documentElement.scrollHeight - window.innerHeight;
    const halfway = totalHeight / 2;
    this.showBackToTop = this.scrollY > halfway;
  }

  /**
   * Smoothly scrolls the window to the top (used by the 'Back to Top' button).
   */
  public scrollToTop(): void {
    this.document.defaultView?.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /**
   * Toggles between light and dark theme
   */
  public toggleTheme(): void {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode();
  }

}
